module.exports = __webpack_public_path__ + "static/2019_FKO_JUMP-474bb59d92361ae8e8f7bd614007f759.jpg";